import React from 'react';

import {useLinkNavigation} from '../../../../../src/components/common/navigation/useLinkNavigation';

export const List = () => {
  const {navigateToLink} = useLinkNavigation();
  return (
    <div>
      <div>List!</div>
      <button type="button" onClick={() => navigateToLink('/knowledge-base/article/1')}>
        Go to article
      </button>
    </div>
  );
};
